module.exports = __webpack_public_path__ + "fonts/Cabin-Medium.1256de6.ttf";